const TOOLBAR_TRIGGER_SELECTOR = "[data-cielo-chat-toolbar-trigger]";
const NATIVE_TRIGGER_SELECTOR = "#cielo-chat-bubble";
const CHAT_WINDOW_SELECTOR = "#cielo-chat-window";

document.addEventListener(
  "click",
  (event) => {
    if (!(event.target instanceof Element)) return;

    const toolbarTrigger = event.target.closest(TOOLBAR_TRIGGER_SELECTOR);
    if (!toolbarTrigger) return;

    const nativeTrigger = document.querySelector(NATIVE_TRIGGER_SELECTOR);
    const chatWindow = document.querySelector(CHAT_WINDOW_SELECTOR);
    if (!(nativeTrigger instanceof HTMLElement) || !chatWindow) return;

    // Kalles can stop this toolbar event before ChatPunch's delegated listener.
    // Forward it to the app-owned button so the app remains responsible for
    // open state, lazy loading, labels and focus behavior.
    event.preventDefault();
    event.stopImmediatePropagation();
    nativeTrigger.click();
  },
  { capture: true },
);
